module.exports = __webpack_public_path__ + "static/media/T9-MongoDB.b63e4ed1.svg";